module.exports = __webpack_public_path__ + "img/cite-de-espace.2c5b3648.jpg";